class VariantSelects extends HTMLElement {
  constructor() {
    super()

    this.root = this.closest('product-info') || this.closest('section') || document
    this.uxUnavailableVariantButtons = this.root
      .querySelector('section[data-unavailable-variant-buttons]')
      ?.getAttribute('data-unavailable-variant-buttons')

    // console.warn(!!this.uxUnavailableVariantButtons)

    this.allOptions = JSON.stringify(
      this.getVariantData().map(({ options }) => options)
    )

    // console.table(this.allOptions)

    this.fieldSets = this.querySelectorAll(
      'fieldset.product-form__input:not(.product-form__quantity)'
    )

    // console.log(this.fieldSets)

    this.fieldSetsSelected = {
      0: '',
      1: '',
      2: '',
    }

    this.templateType = this.root
      .querySelector('section[data-template-type]')
      ?.getAttribute('data-template-type')

    this.step = 1
    this.productMedia = this.root.querySelectorAll(
      '.product__media-item .product__media > img'
    )
    this.productMediaModal = this.root.querySelectorAll(
      '.product-media-modal__content > img'
    )

    // Get all option1 values and create a unique array
    this.pods = [
      ...new Set(this.getVariantData().map(({ option1 }) => option1)),
    ]

    if (!!this.uxUnavailableVariantButtons) this.disableVariantButtons()

    const requestedId = new URLSearchParams(window.location.search).get('variant')
    const initialVariant = this.getVariantData().find(({ id }) => String(id) === requestedId)
    this.previousPod = initialVariant?.option1 || this.pods[0]
    this.selectedPod = this.previousPod

    if (this.templateType === 'join') this.hideImages()

    this.addEventListener('change', this.onVariantChange)
  }

  disableVariantButtons() {
    if (!this.fieldSets) return

    // 1. Set fieldset currently selected value (Pod type, Vest type and Size)
    this.fieldSets.forEach((item, index) => {
      item.querySelectorAll('input').forEach((input) => {
        if (input.checked) {
          this.fieldSetsSelected[index] = input.value
        }
      })
    })

    // 2. Set custom data-option-choice attribute on each label
    this.fieldSets.forEach((item, index) => {
      this.setLabelAttribute(item, index, this.fieldSets.length)
    })

    // 3.
    const handler = (item) => {
      item.querySelectorAll('label').forEach((label) => {
        label.classList.remove('disable-variant-button')

        const current = JSON.stringify(
          label.getAttribute('data-option-choice').split(',')
        )

        const result = this.allOptions.indexOf(current)
        if (result !== -1) {
          // console.log('exists')
        } else {
          // console.log(label.getAttribute('data-option-choice'), 'does not exist')
          label.classList.add('disable-variant-button')
        }
      })
    }

    if (this.fieldSets.length === 3) {
      handler(this.fieldSets[2])
    } else {
      this.fieldSets.forEach((item, index) => {
        if (index === 0) return
        handler(item)
      })
    }
  }

  setLabelAttribute(fieldSet, targetIndex = 2, length = 3) {
    if (!(fieldSet instanceof Element)) return

    const optionArray = (label) => {
      let newArray = []

      for (let index = 0; index < length; index++) {
        if (index === targetIndex) {
          newArray[index] = label.previousElementSibling.value
        } else {
          newArray[index] = this.fieldSetsSelected[index]
        }
      }
      // console.log(newArray)
      return newArray
    }

    fieldSet.querySelectorAll('label').forEach((label) => {
      label.setAttribute('data-option-choice', optionArray(label))
    })
  }

  clearImages() {
    this.productMedia.forEach((item) =>
      item.closest('li').classList.remove('hidden')
    )

    this.productMediaModal.forEach((item) => item.classList.remove('hidden'))
  }

  hideImages() {
    // product gallery list
    const hideImages = Array.from(this.productMedia).filter(
      (item) => !item.alt.includes(this.selectedPod)
    )
    hideImages.forEach((image) => {
      const parent = image.closest('li')
      parent.classList.add('hidden')
    })

    // modal
    const hideModalImages = Array.from(this.productMediaModal).filter(
      (item) => !item.alt.includes(this.selectedPod)
    )
    hideModalImages.forEach((image) => {
      image.classList.add('hidden')
    })
  }

  onVariantChange() {
    if (!!this.uxUnavailableVariantButtons) this.disableVariantButtons()
    this.updateOptions()
    this.updateMasterId()
    this.root.dataset.variantAvailable = String(!!this.currentVariant?.available)
    this.updateVariantInput()
    this.requestController?.abort()
    this.toggleAddButton(true, '', false)
    this.clearImages()
    // this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
      this.announceSelection()
    } else {
      this.selectedPod = this.currentVariant.option1

      this.updateMedia()
      if (this.templateType === 'join') this.hideImages()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return
    this.root.querySelector('media-gallery')?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, false)
  }

  updateURL() {
    if (!this.currentVariant) return
    const url = new URL(window.location.href)
    url.searchParams.set('variant', this.currentVariant.id)
    window.history.replaceState({}, '', url)
  }

  updateVariantInput() {
    this.root.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = this.currentVariant?.available ? this.currentVariant.id : ''
      input.disabled = !this.currentVariant?.available
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  async renderProductInfo() {
    const variant = this.currentVariant
    this.requestController = new AbortController()
    const price = this.root.querySelector(`[id="price-${this.dataset.section}"]`)
    try {
      const url = new URL(this.dataset.url, window.location.origin)
      url.searchParams.set('variant', variant.id)
      url.searchParams.set('section_id', this.dataset.section)
      const response = await fetch(url, { signal: this.requestController.signal })
      if (!response.ok) throw new Error(window.cartStrings.error)
      const html = new DOMParser().parseFromString(await response.text(), 'text/html')
      if (this.currentVariant?.id !== variant.id) return
      const source = html.getElementById(`price-${this.dataset.section}`)
      if (source && price) price.innerHTML = source.innerHTML
      price?.classList.remove('visibility-hidden')
      this.toggleAddButton(!variant.available, window.variantStrings.soldOut)
      this.announceSelection()
    } catch (error) {
      if (error.name === 'AbortError') return
      this.toggleAddButton(true)
      const message = this.root.querySelector('.product-form__error-message')
      if (message) { message.textContent = window.cartStrings.error; message.hidden = false }
    }
  }

  announceSelection() {
    const region = this.root.querySelector('[data-product-selection-status]')
    if (!region) return
    const price = this.root.querySelector(`[id="price-${this.dataset.section}"] .price-item--sale, [id="price-${this.dataset.section}"] .price__regular .price-item`)
    const status = !this.currentVariant ? window.variantStrings.unavailable :
      this.currentVariant.available ? region.dataset.inStock : window.variantStrings.soldOut
    region.textContent = [this.currentVariant?.title, this.currentVariant ? price?.textContent.trim() : '', status].filter(Boolean).join('. ')
  }

  toggleAddButton(disable = true, text) {
    const form = this.root.querySelector(`[id="product-form-${this.dataset.section}"]`)
    if (!form) return
    Array.from(form.elements).filter((element) => element.type === 'submit').forEach((button) => {
      button.disabled = disable || form.closest('product-form').hasAttribute('aria-busy')
      if (text && disable) button.textContent = text
      else if (!disable) button.textContent = form.closest('product-form').dataset.submitLabel || window.variantStrings.addToCart
    })
  }

  setUnavailable() {
    this.toggleAddButton(true, window.variantStrings.unavailable)
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getImagesOffsetTop() {
    const imagesOffsetTop = []
    const images = Array.from(
      document.querySelectorAll('.product__media-item')
    ).filter((image) => !image.classList.contains('hidden'))

    images.forEach(function (image) {
      imagesOffsetTop.push(image.offsetTop)
    })

    return imagesOffsetTop
  }

  scrollProductImage() {
    // console.log('scrollProductImage()')
    if (window.innerWidth < 990) return

    const offsetTop = this.getImagesOffsetTop()
    const productMediaList = document.querySelector('.product__media-list')

    productMediaList.scroll({
      top: offsetTop[this.step],
      behavior: 'smooth',
    })
    this.step < offsetTop.length - 1 ? this.step++ : (this.step = 0)
  }
}

if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

if (!customElements.get('variant-radios')) customElements.define('variant-radios', VariantRadios)
